import React from 'react'

export default () => (
  <div>
    <div style={{ margin: '5px 0 20px 2px', fontSize: 12 }}>
      You may opt out this customer from all marketing
    </div>
  </div>
)